/* eslint-disable */
import auth from './auth' // eslint-disable-next-line
import { createRouter, createWebHashHistory } from 'vue-router'

import defaultLayout from './components/component.nav/side-nav-outer-toolbar'
import simpleLayout from './components/component.ui/single-card'

function loadView(view) {
    return () =>
        import (
            /* webpackChunkName: "login" */
            `./components/component.login/${view}.vue`
        )
}
function loadViewMenu(view) {
    return () =>
        import (
            /* webpackChunkName: "menu" */
            `./components/component.menu/${view}.vue`
        )
}
function loadViewUtils(view) {
    return () =>
        import (
            /* webpackChunkName: "utils" */
            `./components/component.utils/${view}.vue`
        )
}
const router = new createRouter({
    routes: [
        {
            path: '/tomo',
            name: 'tomo',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('tomo-volume'),
        },
        {
            path: '/video-guides',
            name: 'video-guides',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('video-guides'),
        },
        {
            path: '/video',
            name: 'video',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('video'),
        },
        {
            path: '/group',
            name: 'group',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('groups'),
        },
        {
            path: '/sub-group',
            name: 'sub-group',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('sub-group'),
        },
        ,
        {
            path: '/keys',
            name: 'keys',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('keys'),
        },
        {
            path: '/auditoria',
            name: 'auditoria',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('log'),
        },
        {
            path: '/quiz',
            name: 'quiz',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('quizzes'),
        },
        {
            path: '/quiz_result',
            name: 'quiz_result',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('quizzes_result'),
        },
        {
            path: '/views',
            name: 'views',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('views'),
        },
        {
            path: '/shop',
            name: 'shop',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('virtual-shop'),
        },
        {
            path: '/users',
            name: 'users',
            meta: {
                requiresAuth: true,
                layout: defaultLayout,
            },
            component: loadViewMenu('users'),
        },
        {
            path: "/change-password-user",
            name: "change-password-user",
            meta: { 
                requiresAuth: true,
                layout: simpleLayout,
                title: 'Cambiar Contraseña'
            },
            component: loadViewUtils('change-password-user')
        },
        {
            path: "/activate_user",
            name: "activate_user",
            meta: { 
                requiresAuth: true,
                layout: simpleLayout,
            },
            component: loadViewUtils('activate_user')
        },
        {
            path: '/login-form',
            name: 'login-form',
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: 'Iniciar Sesión',
            },
            component: loadView('login-form'),
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: 'Restablecer contraseña',
                description: 'Introduzca la dirección de correo electrónico que utilizó para registrarse y le enviaremos un enlace para restablecer su contraseña por correo electrónico.',
            },
            component: loadView('reset-password-form'),
        },
        {
            path: '/create-account',
            name: 'create-account',
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: 'Registrar Usuario',
            },
            component: loadViewUtils('create-account-form'),
        },
        {
            path: '/change-password',
            name: 'change-password',
            meta: {
                requiresAuth: false,
                layout: simpleLayout,
                title: 'Change Password',
            },
            component: loadView('change-password-form'),
        },
        {
            path: '/',
            redirect: '/tomo',
        },
        {
            path: '/recovery',
            redirect: '/tomo',
        },
        {
            path: '/auditoria/:user_id',
            redirect: '/auditoria',
        },
        {
            path: '/views/:user_id',
            redirect: '/views',
        }
        
    ],
    history: createWebHashHistory(),
})

router.beforeEach((to, from, next) => {
    if (to.name === 'login-form' && auth.authenticated()) {
        next({ name: 'tomo' })
    }
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!auth.authenticated()) {
            next({
                name: 'login-form',
                query: { redirect: to.fullPath },
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router